export default {
  EXPLORE_MORE: "Узнать больше",
  TITLE_HOME: "Ryspekov | Главная",
  TITLE_ABOUT: "Ryspekov | Обо мне",
  TITLE_CONTACTS: "Ryspekov | Контакты",
  HOME_NAME: "Рыспеков Ансар",
  HOME_SUB: "Программист | Человек науки",
  NAV_HOME: "Главная",
  NAV_ABOUT: "Обо мне",
  NAV_TIMELAPSE: "История",
  NAV_PROJECTS: "Проекты",
  NAV_CONTACTS: "Контакты",
  CONTACTS_TITLE: "Свяжитесь со мной",
  CONTACTS_SUB_TITLE: "Ответ в течении 24 часов<br/>(местное время UTC +6.00)",
  about_main_title: "Миру нужны люди способные решать его проблемы",
  about_main_subtitle: "Позвольте мне стать одним из них",
  about_soft_title: "Кто я?",
  about_soft_blocks: [
    {
      title: "Меня зовут Ансар",
      text:
        'Я родом из красивого города Алматы, что дословно переводится как "Отец Яблок". С детства я мечтал о небе и звездах, сейчас к этим мечтам добавились цели и идеи.',
    },
    {
      title: "Я инженер",
      text:
        "Пока я покоряю Computer Science, люблю занимать себя веб разработкой, созданием игр, изучением естественных наук и чтением книг.",
    },
    {
      title: "Red Crescent",
      text:
        "После трагичной гибели одного замечательного человека, я решил стать частью этого движения. Подобная деятельность позволяет мне шире взглянуть на ситуацию в мире и как можно эти проблемы решить.",
    },
    {
      title: "Я думаю об экологии",
      text:
        "Экологическая ситуация на планете сильно пугает, необходимо принимать решения на этот счет. Небольшими усилиями многих мы способны предотвратить катастрофу.",
    },
  ],
  about_hard_title: "Интересуют мои технические навыки?",
  about_hard_blocks: ["WEB", "Теория", "Опыт", "Инструменты"],
  about_hard_intro: "Что я умею",
  about_hard_intro_blocks: [
    "Создавать Сайты",
    "Целевые Страницы",
    "Веб Приложения",
    "Интернет Магазины",
    "Отзывчивые, Адаптивные Сайты",
    "Оптимизация",
    "Писать Скрипты",
    "И другое программирование",
  ],
};
